<template>
  <div class="tpl-wrap">
    <ListFilter 
      :formList="filterFormList" 
      @search="searchHandle" 
      wstyle="background-color: transparent;padding: 0;" 
      @newadd="editHandle(true)"
      :newadd="tabs?.length > 1"
    />
    <div class="tpllist-wrap">
      <div class="tpllist-tabs">
        <template v-for="(item, index) in tabs">
          <div class="item" :class="{ selected: item?.id == curTab?.id }" @click="toggleTab(index)">
            <span>{{ item?.appCodeName }}{{ !!item?.total && `（${item?.total}）` || '' }}</span>
          </div>
        </template>
      </div>
      <div class="tpllist-items-wrap">
        <div class="tpllist-items">
          <div class="tpllist-items-in" v-if="list?.length > 0">
            <div class="tpllistitem" v-for="(item, index) in list" :key="index">
              <div class="item"><label>模版名称</label><span>{{item?.templateName || '-'}}</span></div>
              <div class="item"><label>模版类型</label><span>{{ item?.appCode && CONST.APP_CODE_LABEL[item.appCode]?.name || item?.appCodeName || '-' }}</span></div>
              <div class="item"><label>使用范围</label><span>{{item?.useModeName || '-'}}</span></div>
              <div class="item"><label>最近更新时间</label><span>{{ item?.updatedTime && moment(item?.updatedTime).format('YYYY/MM/DD HH:mm:ss') || '-' }}</span></div>
              <div class="item"><label>备注</label><span>{{item?.note || '-'}}</span></div>

              <el-popconfirm :title="failDel ? '此模版目前被其他项目引用，暂不可删除。' : '你确定要删除模板吗？'" width="208px">
                <template #reference>
                  <!-- <em class="delete"><el-icon><Delete /></el-icon></em> -->
                  <em class="delete" />
                </template>
                <template #actions="{ confirm, cancel }">
                  <template v-if="failDel">
                    <el-button size="small" type="primary" @click="cancel">知道了</el-button>
                  </template>
                  <template v-else>
                    <el-button size="small" @click="cancel">取消</el-button>
                    <el-button type="primary" size="small" @click="deleteHandle(item, confirm)">确定</el-button>
                  </template>
                </template>
              </el-popconfirm>
              <!-- <em class="edit"><el-icon><EditPen /></el-icon></em> -->
              <em class="edit" @click="editHandle(true, item)" />
            </div>
          </div>
          <Empty v-else />
        </div>
        <Spagination 
          v-if="total > 0"
          wstyle="margin-top: 0;"
          :page="page"
          :size="size"
          :total="total"
          @current-change="val => page = val"
        />
      </div>
    </div>
  </div>

  <Editor :carrier="data?.code" :apps="tabs" :appCode="editTarget?.appCode || defaultEditorAppCode" :id="editTarget?.id || ''" v-if="editFlag" @cancel="editHandle(false)" @refresh="getList" />
</template>

<script setup>
  import {onMounted, ref, watch, computed} from 'vue';
  import { EditPen, Delete } from '@element-plus/icons-vue';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import Empty from '@/components/empty';
  import Editor from '../editor';
  import * as Request from '@/assets/request'
  import * as CONST from '@/assets/const'
  import moment from 'moment';
  import { ElMessage } from 'element-plus';

  const props = defineProps({
    data: {
      type: Object,
      default: null
    }
  })

  /**
   * 筛选
   */
  const filterFormList = ref([])
  const filterFormListInit = () => {
    filterFormList.value = [
    {
        type: 'select', field: 'useMode',
        label: '使用范围', placeholder: '请选择',
        options: Object.keys(CONST.USE_MODE_LABEL).map(value => ({ value: Number(value), label: CONST.USE_MODE_LABEL[value] }))
      },
      // {
      //   type: 'select', field: 'appCode',
      //   label: '模版类型', placeholder: '请选择',
      //   options: []
      // },
      {
        type: 'input', field: 'templateName',
        label: '模版名称', placeholder: '请输入',
      },
    ]
  }
  onMounted(() => {
    filterFormListInit()
  })
  
  // 搜索
  const searchHandle = data => {
    console.log('curTab--', curTab)
    listQuery.value = { ...data };
    if(curTab.value?.appCode) {
      listQuery.value.appCode = curTab.value.appCode;
    }
    page.value = 1;
  }

  /**
   * 列表
   */
  // tabs
  const tabs = ref([]);
  const curTab = ref(null);
  const allAppData = ref(null)
  const getAllAppData = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getAllApp'
    });
    if(result?.code != 200) return;
    allAppData.value = result?.data
  }
  const initTabs = async () => {
    if(!allAppData.value){
      await getAllAppData();
    }
    
    let _options = [ { gid: null, id: null, appCode: 'all', appCodeName: '全部模版', total: 0 } ];
    if(allAppData.value?.length > 0) {
      allAppData.value.map(item => {
        if(item?.group?.code == props.data?.code && item?.apps?.length > 0) {
          item.apps.map(_item => {
            if(_item?.name && _item?.appCode != CONST.APP_CODE_QUERY_TRACKER) {
              _options.push({ 
                gid: item?.group?.id,
                id: _item?.id,
                appCode: _item?.appCode,
                appCodeName: _item?.name
              });
            }
          })
        }
      })
    }
    tabs.value = _options;
  }
  console.log('tabs', tabs.value)
  const toggleTab = index => {
    curTab.value = tabs.value[index]
    page.value = 1
    listQuery.value = {
      ...listQuery.value,
      // appCode: curTab.value?.appCode
      appId: curTab.value?.id
    }
  }
  onMounted(() => {
    initTabs()
    toggleTab(0)
  })
  watch(() => props.data, () => {
    initTabs()
    toggleTab(0)
  })

  // list
  const list = ref([])
  const listQuery = ref({})
  const total = ref(0)
  const size = ref(50)
  const page = ref(1)
  const getList = async () => {
    if(listQuery.value?.appCode == 'all') {
      delete listQuery.value.appCode;
    }
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/searchList',
      data: {
        ...listQuery.value,
        carrierCode: props?.data?.code,
        page: page.value,
        size: size.value
      }
    })
    if(result?.code != 200) return;
    
    list.value = result.data.content;
    total.value = result.data.total;

    if(!curTab.value?.appCode || curTab.value?.appCode == 'all') {
      tabs.value.map(tebItem => {
        if(tebItem.appCode == 'all') {
          tebItem.total = total.value || 0
        }
        return tebItem;
      })
    }
  }
  watch(() => [ listQuery.value, page.value ], () => {
    getList();
  }, { deep: true })

  /**
   * 操作
   */
  // 删除
  const failDel = ref(false);
  const deleteHandle = async (item, callback) => {
    // failDel.value = true;
    console.log('item--', item)
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/delete',
      data: item?.id
    })
    if(result?.code != 200) return;
    ElMessage.success('已删除');
    getList()
  }

  /**
   * 新增&编辑
   */
  const editFlag = ref(false);
  const editTarget = ref(null)
  const editHandle = (flag, data = null) => {
    console.log('data-----', data)
    editFlag.value = flag;
    editTarget.value = flag ? data : null
  }
  // 新增时，编辑器默认模版类型跟随当前选中的分类 tab（“全部模版”时取第一个具体类型）
  const defaultEditorAppCode = computed(() => {
    if(curTab.value?.appCode && curTab.value.appCode != 'all') return curTab.value.appCode;
    return tabs.value[1]?.appCode || '';
  })
</script>

<style scoped lang="less">
  @import "./index.less";
</style>